<!-- 添加裂变活动 -->
<template>
  <div class="container">
    <el-page-header class="page-header" @back="goBack" content="裂变工具">
    </el-page-header>

    <el-collapse v-model="activeNames" style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>设置的红包金额为单个红包固定金额；且实物与红包仅支持线下兑奖</p>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="main" >
      <el-steps :active="step" finish-status="success">
        <el-step class="ex-cls"  title="活动信息" @click.native="step = 1"></el-step>
        <el-step class="ex-cls"  title="活动奖品" @click.native="step = 2"></el-step>
        <el-step class="ex-cls"  title="高级设置" @click.native="step = 3"></el-step>
        <el-step class="ex-cls"  title="活动海报" @click.native="step = 4"></el-step>
        <el-step class="ex-cls"  title="活动欢迎语" @click.native="step = 5"></el-step>
      </el-steps>
      <div class="form">
        <div class="form-step-1" v-show="step == 1">
          <el-form ref="step1" :model="step1Model" :rules="step1Rules" label-width="12.0rem">
            <el-form-item label="活动名称:" prop="activity_name">
              <el-input style="width: 47.0rem" v-model="step1Model.activity_name" minlength="2" maxlength="20"
                show-word-limit size="small" placeholder="请输入活动名称"></el-input>
            </el-form-item>
            <el-form-item label="活动时间:" prop="activity_time">
              <el-date-picker v-model="step1Model.activity_time" type="datetimerange" align="right" size="small"
                start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['08:00:00', '08:00:00']">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </div>
        <div class="form-step-2" v-show="step == 2">
          <el-form ref="step2" :model="step2Model" :rules="step2Rules" label-width="12.0rem">
            <el-form-item label="裂变人数:" prop="people_number">
              <span class="el-form-item__content">
                需要拉<el-input class="clear-number-input" style="width: 6.0rem; margin: 0 .6rem" size="mini" type="number"
                  v-model="step2Model.people_number"></el-input>好友可领礼物
              </span>
            </el-form-item>
            <el-form-item label="奖品类型:" prop="fission_type">
              <el-radio-group v-model="step2Model.fission_type">
                <el-radio :label="1">实物</el-radio>
                <el-radio :label="2">红包</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="step2Model.fission_type == 1" label="奖品名称:" prop="prize_name">
              <el-input style="width: 47.0rem" v-model="step2Model.prize_name" size="small" minlength="2" maxlength="20"
                show-word-limit placeholder="请输入奖品名称"></el-input>
            </el-form-item>
            <el-form-item v-if="step2Model.fission_type == 1" label="奖品数量:" prop="prize_number">
              <el-input style="width: 6.0rem" class="clear-number-input" type="number" size="mini"
                v-model="step2Model.prize_number" placeholder=""></el-input>
              个
            </el-form-item>
            <el-form-item v-if="step2Model.fission_type == 2" label="红包金额:" prop="money_total">
              <el-input style="width: 6.0rem" class="clear-number-input" type="number" size="mini"
                v-model="step2Model.money_total" placeholder=""></el-input>
              元
            </el-form-item>
            <el-form-item v-if="step2Model.fission_type == 2" label="红包数量:" size="mini" prop="money_number">
              <el-input style="width: 6.0rem" class="clear-number-input" type="number" size="mini"
                v-model="step2Model.money_number" placeholder=""></el-input>
              个
            </el-form-item>
            <el-form-item label="联系客服:" prop="support_user_id">
              <div class="person">
                <el-tag v-if="support_user.name" style="margin: .0rem 1.2rem 0 0"  effect="plain">
                  {{ support_user.name }}
                </el-tag>
              </div>
              <el-button :style="{ marginTop: support_user.name ? '.8rem' : '0' }" icon="el-icon-plus" size="small"
                @click="onSelectSupportPerson">选择员工</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="form-step-3" v-show="step == 3">
          <el-form ref="step3" :model="step3Model" :rules="step3Rules" label-width="12.0rem">
            <el-form-item label="性别参与:" prop="gender_limit">
              <el-radio-group v-model="step3Model.gender_limit">
                <el-radio :label="1">不限制</el-radio>
                <el-radio :label="2">男性</el-radio>
                <el-radio :label="3">女性</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="地区参与:" prop="area_limit">
              <el-radio-group v-model="step3Model.area_limit">
                <el-radio :label="1">不限制</el-radio>
                <el-radio :label="2">部分地区参与</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item prop="area" v-show="step3Model.area_limit == 2">
              <div class="item" v-for="(i, ind) in temNum" :key="ind">
                <el-cascader v-model="value1[ind]" :options="form.provinceList"
                  :props="{ value: 'name', label: 'name', children: 'children' }"
                  @change="provinceChange(ind)"></el-cascader>
                <el-cascader v-model="value2[ind]" :options="form.cityList[ind]"
                  :props="{ value: 'name', label: 'name', children: 'children' }" @change="cityChange(ind)"></el-cascader>
                <el-cascader v-model="value3[ind]" :options="form.countyList[ind]"
                  :props="{ value: 'name', label: 'name', children: 'children' }" @change="cityChange(ind)"></el-cascader>
                <div class="btn">

                  <el-button type="text" style="color:#49B374 !important;margin-left:2.0rem;padding-right: .0rem !important;" v-show="ind == temNum - 1" @click="addArea">添加</el-button>
                  <el-button type="text" style="color:#f00 !important;margin-left:2.0rem" v-show="temNum > 1" @click="delArea(ind)">删除</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="好友助力次数:">
              <el-input class="clear-number-input" style="width: 6.0rem" v-model="step3Model.help_number" size="mini"
                type="number"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="form-step-4" v-show="step == 4">
          <div class="form-step-4-left">
            <div class="background">
              <div class="background-img-box">
                <img class="background-img" :src="step4Model.background_url" />
                <div v-if="step4Model.background_if_avatar == 1" class="avatar draggable resizable vdr radus" style="
                                                transform: translate(3.0rem, 54.5rem);
                                                z-index: 9999;
                                                user-select: auto;
                                                cursor: move;
                                                width: 5.2rem;
                                                height: 5.2rem;
                                              ">
                  <span style="
                                                  display: inline-block;
                                                  position: absolute;
                                                  left: 50%;
                                                  top: 50%;
                                                  transform: translate(-50%, -50%);
                                                  font-size: 1.2rem;
                                                ">头像</span>
                </div>
                <div v-if="step4Model.background_if_nickname == 1" class="nickname draggable vdr" style="
                                                transform: translate(3.6rem, 60.2rem);
                                                z-index: 9999;
                                                user-select: auto;
                                                cursor: move;
                                                font-size: 1.4rem;
                                                color: rgb(255, 255, 255);
                                                line-height: 2.4rem;
                                                text-align: left;
                                                width: 8.4rem;
                                                height: 2.8rem;
                                              ">
                  昵称
                </div>
                <div class="qrcode draggable resizable vdr" style="
                                                transform: translate(25.1rem, 53.4rem);
                                                z-index: 9999;
                                                user-select: auto;
                                                cursor: move;
                                                width: 10.1rem;
                                                height: 10.1rem;
                                              ">
                  <img
                    src="http://work-1302521284.cos.ap-beijing.myqcloud.com/weijub/1635302549%E4%BA%8C%E7%BB%B4%E7%A0%81.png"
                    style="width: 9.0rem; height: 9.0rem" />
                </div>
              </div>
            </div>
          </div>
          <div class="form-step-4-right">
            <el-form ref="step4" :model="step4Model" :rules="step4Rules" label-width="12.0rem">
              <el-form-item label="海报图片:" prop="background_url">
                <div v-if="step4Model.background_url">
                  <el-image style="width: 7.2rem; height: 12.8rem" :src="step4Model.background_url"
                    :preview-src-list="[step4Model.background_url]"></el-image>
                </div>
                <el-upload class="upload-demo" accept=".jpg,.bmp,.png" :show-file-list="false"
                  :action="`${axios.defaults.baseURL}/api/Alioss/uploadTotal`" :before-upload="handleBeforeUploadBg"
                  :on-success="handleSuccessBg">
                  <el-button icon="el-icon-upload2" size="small" :loading="uoloadBgBtnLoading"
                    :disabled="uoloadBgBtnLoading">重新上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    图片像素建议为750*1334像素，格式为jpg、bmp、png，大小不超过2M
                  </div>
                </el-upload>
              </el-form-item>
              <el-form-item label="头像" prop="background_if_avatar">
                <el-switch v-model="step4Model.background_if_avatar" :active-value="1" :inactive-value="2"></el-switch>
              </el-form-item>
              <el-form-item label="昵称" prop="background_if_nickname">
                <el-switch v-model="step4Model.background_if_nickname" :active-value="1" :inactive-value="2"></el-switch>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="form-step-5" v-show="step == 5">
          <div class="form-step-5-left">
            <el-form ref="step5" :model="step5Model" :rules="step5Rules" label-width="12.0rem">
              <el-form-item label="引流设置:">
                <span class="el-form-item__content">
                  海报将展示对应带参数的二维码， 扫码后将引流到对应的企业成员
                </span>
              </el-form-item>
              <el-form-item label="引流成员:" prop="user_id">
                <div class="person">
                  <el-tag v-for="(u, index) in users" :key="index" style="margin: 1.2rem 1.2rem 0 0" type="info"
                    effect="plain">
                    {{ u.name }}
                  </el-tag>
                </div>
                <el-button icon="el-icon-plus" size="small" @click="onSelectUserPerson">选择员工</el-button>
              </el-form-item>
              <el-form-item label="设置欢迎语:">
                <span class="el-form-item__content">
                  客户通过海报添加对应微信后，可自动发送设置的内容
                </span>
              </el-form-item>
              <el-form-item label="文本:" prop="activity_content">
                <el-input type="textarea" autosize="true" style="width: 47.0rem" v-model="step5Model.activity_content"
                  maxlength="4000" placeholder="请输入欢迎语文本"></el-input>
              </el-form-item>
              <el-form-item label="图文封面:" prop="activity_image">
                <div v-if="step5Model.activity_image">
                  <el-image style="width: 10.0rem; height: 10.0rem" :src="step5Model.activity_image"
                    :preview-src-list="[step5Model.activity_image]"></el-image>
                </div>
                <el-upload class="upload-demo" accept="jpeg,.jpg,.bmp,.png" :data="upParams" :show-file-list="false"
                  :action="
                    this.axios.defaults.baseURL +
                    '/api/Alioss/upload_temp_uploadimg'
                  " :before-upload="handleBeforeUploadCover" :on-success="handleSuccessCover">
                  <el-button type="primary" icon="el-icon-upload2" size="small" :loading="uoloadCoverBtnLoading"
                    :disabled="uoloadCoverBtnLoading">重新上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    图片大小不超过2M，支持JPG、JPEG及PNG格式。建议尺寸200*200
                  </div>
                </el-upload>
              </el-form-item>
              <el-form-item label="填写标题:" prop="activity_title">
                <el-input style="width: 47.0rem" v-model="step5Model.activity_title" placeholder="请填写欢迎语标题" maxlength="32"
                  show-word-limit></el-input>
              </el-form-item>
              <el-form-item label="添加描述:" prop="activity_describe">
                <el-input style="width: 47.0rem" type="textarea" autosize="true" v-model="step5Model.activity_describe"
                  placeholder="请填写欢迎语描述" maxlength="255" show-word-limit></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="form-step-5-right">
            <img class="mobile-header-img" src="../../assets/smartPhone.png" style="position: absolute" alt=""
              srcset="" />
            <div class="mobile">
              <div class="mobile-main">
                <div class="list">
                  <div class="list-item" v-show="step5Model.activity_content">
                    <div class="list-item-l">
                      <img class="list-item-l-avatar" :src="
                        (users[0] && users[0].avatar) ||
                        'https://wework.qpic.cn/wwpic/78231_MYQyIsX2Tz6h03l_1655191115/0'
                      " />
                    </div>
                    <div class="list-item-r">
                      {{ step5Model.activity_content }}
                    </div>
                  </div>
                  <div class="list-item">
                    <div class="list-item-l">
                      <img class="list-item-l-avatar" :src="
                        (users[0] && users[0].avatar) ||
                        'https://wework.qpic.cn/wwpic/78231_MYQyIsX2Tz6h03l_1655191115/0'
                      " />
                    </div>
                    <div class="list-item-r">
                      <div class="list-item-r-t">
                        {{ step5Model.activity_title }}
                      </div>
                      <div class="list-item-r-b">
                        <div class="list-item-r-b-l">
                          {{ step5Model.activity_describe }}
                        </div>
                        <div class="list-item-r-b-r" v-show="step5Model.activity_image">
                          <img :src="step5Model.activity_image" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer" >
        <div class="footer-box">
          <el-button v-show="step > 1" size="small" @click="onPrev">上一步</el-button>
          <el-button v-show="step < 5" type="primary" size="small" @click="onNext">下一步</el-button>
          <el-button v-show="step == 5" type="primary" size="small" :loading="submitLoading" :disabled="submitLoading"
            @click="onSubmit">提交</el-button>
        </div>
      </div>
    </div>
    <right-people ref="dialog" :checkbox="checkbox" :selectData="selectData" @handleSelect="handleSelect"></right-people>
  </div>
</template>

<script>
import rightPeople from '@/components/drawer/rightPeople';
import { regionData, CodeToText } from "element-china-area-data";
export default {
  name: "fissionToolsAdd",
  components: {
    rightPeople
  },

  data() {
    return {
      step: 1,
      step1Model: {
        activity_name: "",
        activity_time: [],
      },
      step1Rules: {
        activity_name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        activity_time: [
          { required: true, message: "请选择活动时间", trigger: "blur" },
        ],
      },
      step2Model: {
        people_number: 10,
        fission_type: 1,
        prize_name: "",
        prize_number: 1,
        support_user_id: "",
        money_total: 1,
        money_number: 1,
      },
      step2Rules: {
        people_number: [
          { required: true, message: "请输入裂变人数", trigger: "blur" },
        ],
        fission_type: [
          { required: true, message: "请选择奖品类型", trigger: "blur" },
        ],
        prize_name: [
          { required: true, message: "请输入奖品名称", trigger: "blur" },
        ],
        prize_number: [
          { required: true, message: "请输入奖品数量", trigger: "blur" },
        ],
        money_total: [
          { required: true, message: "请输入红包金额", trigger: "blur" },
        ],
        money_number: [
          { required: true, message: "请输入红包数量", trigger: "blur" },
        ],
        support_user_id: [
          { required: true, message: "请选择联系客服", trigger: "blur" },
        ],
      },
      step3Model: {
        gender_limit: 1,
        area_limit: 1,
        area: [[]],
        help_number: 1,
      },
      step3Rules: {
        gender_limit: [
          { required: true, message: "请选择性别", trigger: "blur" },
        ],
        area_limit: [
          {
            required: true,
            message: "请选择地区参与",
            trigger: "blur",
          },
        ],
        help_number: [
          { required: true, message: "请输入好友助力次数", trigger: "blur" },
        ],
      },
      step4Model: {
        background_url:
          "http://work-1302521284.cos.ap-beijing.myqcloud.com/weijub/1635832833poster_20211101171611.jpg",
        background_if_nickname: 1,
        background_if_avatar: 1,
      },
      step4Rules: {
        background_url: [
          { required: true, message: "请上传海报图片", trigger: "blur" },
        ],
      },
      step5Model: {
        user_id: "",
        activity_image:
          "https://wework.qpic.cn/wwpic/731812_j8MsoYLMTsG4lcQ_1635832901/0",
        activity_media_id:
          "30VPA0QA4GGiV5RfDqVY-vvC-z5Y5wbShTzhJkdSCBGk8xvPymDRkaJCMskofangL",
        activity_content: "欢迎参加我的活动",
        activity_title: "欢迎语标题",
        activity_describe: "这个活动很精彩欢迎使用",
      },
      step5Rules: {
        user_id: [
          { required: true, message: "请选择引流成员", trigger: "blur" },
        ],
        activity_content: [
          { required: true, message: "请输入欢迎语文本", trigger: "blur" },
        ],
        activity_image: [
          { required: true, message: "请上传图文封面", trigger: "blur" },
        ],
        activity_title: [
          { required: true, message: "请输入欢迎语标题", trigger: "blur" },
        ],
        activity_describe: [
          { required: true, message: "请输入欢迎语描述", trigger: "blur" },
          {
            min: 0,
            max: 255,
            message: "长度在255个字符之内",
            trigger: "blur",
          },
        ],
      },
      area: regionData,
      support_user: {},
      selectData: [],
      module: "",
      selectionDepartment: false,
      selectionName: true,
      checkbox: false,
      uoloadBgBtnLoading: false,
      users: [],
      m: "support",
      uoloadCoverBtnLoading: false,
      upParams: {},
      submitLoading: false,
      activeNames: [],
      //地区选择需要用的字段
      value1: [],
      value2: [],
      value3: [],
      form: {
        provinceList: [],
        cityList: [],
        countyList: []
      },
      provinceList: [],
      cityList: [],
      countryList: [],
      CITY: [],
      XIAN: [],
      mulValue: [],
      temNum: 1,
      temVal: [],
      subData: []
    };
  },

  computed: {},

  mounted() {
    this.upParams.account_id = this.tooken.account_id;
    this.initArea()
  },

  methods: {
    handleBeforeUploadBg() {
      this.uoloadBgBtnLoading = true;
    },
    handleSuccessBg(res, file, fileList) {
      // 上传背景图
      if (res.code == 1) {
        this.step4Model.background_url = res.data.url;
      } else {
        this.$message.error(res.msg);
      }
      this.uoloadBgBtnLoading = false;
    },
    handleBeforeUploadCover() {
      this.uoloadCoverBtnLoading = true;
    },
    handleSuccessCover(res, file, fileList) {
      // 上传欢迎语封面
      if (res.code == 1) {
        this.step5Model.activity_image = res.data.url;
        this.step5Model.activity_media_id = res.data.media_id;
      } else {
        this.$message.error(res.msg);
      }
      this.uoloadCoverBtnLoading = false;
    },
    onAddAreaItem() {
      // 地区限制后增加地区
      this.step3Model.area.push([]);
    },
    onDelAreaItem(index) {
      this.step3Model.area.splice(index, 1);
    },
    onSelectSupportPerson() {
      // 打开选择联系客服弹窗
      this.m = "support";
      this.selectData = this.support_user;
      this.selectionDepartment = true;
      this.checkbox = false;
      this.module = "getAddressBook";
      this.$refs.dialog.open();
    },
    onSelectUserPerson() {
      this.m = "users";
      this.selectData = this.users;
      this.selectionDepartment = true;
      this.checkbox = true;
      this.module = "getAddressBook";
      this.$refs.dialog.open();
    },
    handleSelect(person) {
      switch (this.m) {
        case "support":
          // 选择了联系客服
          this.support_user = person;
          this.step2Model.support_user_id = this.support_user.userid;
          break;
        case "users":
          // 选择引流员工
          this.users = person;
          const userid = person.map((i) => {
            return i.userid;
          });
          this.step5Model.user_id = userid.toString();
          break;
        default:
          break;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    onPrev() {
      this.step--;
    },
    onNext() {
      if (this.step3Model.area_limit == 2) {
        if (this.step3Model.area == false) {
          this.step = 3
          this.$message.error('请选择地区');
          return
        }
      }

      // 下一步
      if (this.value1.length) {

        this.handleVal()
      }
      this.validateForm();
    },
    validateForm() {
      // 每个阶段的表单校验
      this.$refs[`step${this.step}`].validate((valid) => {
        if (valid) {
          this.step++;
        } else {
          return false;
        }
      });
    },
    validateFormSubmit() {
      // 最终提交时对每个阶段的表单校验
      const array = [1, 2, 3, 4, 5];
      let isSubmit = true;
      for (let index = 1; index <= array.length; index++) {
        this.$refs[`step${index}`].validate((valid) => {
          if (valid) {
            console.log(valid);
          } else {
            this.step = index;
            isSubmit = false;
            return false;
          }
        });
      }
      return isSubmit;
    },
    async onSubmit() {
      const isSubmit = this.validateFormSubmit();
      // 校验条件没有通过直接返回就行，不调用接口API
      if (!isSubmit) {
        return;
      }
      if (this.step3Model.area_limit == 2) {
        if (this.step3Model.area == false) {
          this.step = 3
          this.$message.error('请选择地区');
          return
        }
      }

      this.addActivityFission();
    },
    async addActivityFission() {
      // let area = [];
      // const areas = this.step3Model.area;
      // for (let index = 0; index < areas.length; index++) {
      //   const element = areas[index];
      //   let province;
      //   let city;
      //   let a;
      //   if (element.length) {
      //     province = CodeToText[element[0]];
      //     city = CodeToText[element[1]];
      //     a = CodeToText[element[2]];
      //     area.push([province, city, a]);
      //   }
      // }

      const data = this.qs.stringify({
        usertoken: this.tooken.usertoken,
        account_id: this.tooken.account_id,
        phone: this.tooken.phone,
        user_id: this.step5Model.user_id,
        activity_name: this.step1Model.activity_name,
        background_url: this.step4Model.background_url,
        background_if_nickname: this.step4Model.background_if_nickname,
        background_if_avatar: this.step4Model.background_if_avatar,
        start_time: Number.parseInt(
          this.step1Model.activity_time[0].getTime() / 1000
        ),
        end_time: Number.parseInt(
          this.step1Model.activity_time[1].getTime() / 1000
        ),
        people_number: this.step2Model.people_number,
        fission_type: this.step2Model.fission_type,
        prize_name: this.step2Model.prize_name,
        prize_number: this.step2Model.prize_number,
        money_total: this.step2Model.money_total,
        money_number: this.step2Model.money_number,
        gender_limit: this.step3Model.gender_limit,
        area_limit: this.step3Model.area_limit,
        area: JSON.stringify(this.subData),
        support_user_id: this.step2Model.support_user_id,
        help_number: this.step3Model.help_number,
        activity_image: this.step5Model.activity_image,
        activity_media_id: this.step5Model.activity_media_id,
        activity_content: this.step5Model.activity_content,
        activity_title: this.step5Model.activity_title,
        activity_describe: this.step5Model.activity_describe,
      });
      this.submitLoading = false;
      const { data: res } = await this.axios({
        url: "/crm/ActivityFission/addActivityFission",
        method: "POST",
        data,
      });
      this.submitLoading = true;
      if (res.code == 1) {
        this.$message.success(res.msg);
        this.goBack();
      } else if (res.code == 0) {
        this.$message.error(res.msg);
      }
    },

    //地区选择需用到的方法
    initArea() {
      this.axios({
        method: "get",
        url: "https://restapi.amap.com/v3/config/district?parameters", // apii请求地址
        params: {  // 携带的参数
          key: "73092d0537b4c8249c9ef1db4fddd51f", // 在高德开放平台申请的个人key密钥
          keyWords: "中国",
          subdistrict: 3    // 要获取的行政区划的级别：省、市、县三级
        }
      }).then((res) => {
        this.form.provinceList = res.data.districts[0].districts  /* 省*/
        /* 进行遍历赋值*/
        /* 市区和县区*/
        let newProvince = this.form.provinceList
        for (let i = 0; i < newProvince.length; i++) {              /* 省级*/
          for (let j = 0; j < newProvince[i].districts.length; j++) {       /* 市级*/
            let city = newProvince[i].districts[j].name
            this.CITY.push({ id: j + 1, name: city, code: i + 1 })
            for (let k = 0; k < newProvince[i].districts[j].districts.length; k++) {/* 县级*/
              let xian = newProvince[i].districts[j].districts[k].name
              this.XIAN.push({ id: k + 1, name: xian, code: j + 1, cityCountyName: city })
            }
          }
        }
        for (let m = 0; m < newProvince.length; m++) {
          newProvince[m] = { ...newProvince[m], ...{ code: m + 1 } }
        }
        this.form.provinceList = newProvince
      })
    },
    addArea() {
      this.temNum += 1
    },
    delArea(e) {
      this.temNum -= 1
      this.value1.splice(e, 1)
      this.value2.splice(e, 1)
      this.value3.splice(e, 1)
      this.form.cityList.splice(e, 1)
      this.form.countyList.splice(e, 1)
    },
    provinceChange(e) {
      // 根据选中省，匹配市
      let cityCode = 0
      this.form.provinceList.forEach((item) => {
        if (item.name == this.value1[e]) {
          cityCode = item.code
        }
      })
      if (cityCode) {
        this.form.cityList[e] = []
        this.CITY.forEach((item, index) => {
          if (item.code == cityCode) {
            this.form.cityList[e].push(item)
          }
        })  /* 市匹配成功*/
      }
    },
    cityChange(e) {
      let countyCode = 0
      let cityName = ''
      this.form.cityList[e].forEach((item) => {
        if (item.name == this.value2[e]) {
          countyCode = item.id
          cityName = item.name
        }
      })
      if (countyCode) {
        this.form.countyList[e] = []
        this.XIAN.forEach((item, index) => {
          if (item.code == countyCode && item.cityCountyName == cityName) {
            this.form.countyList[e].push(item)
          }
        })
      }
    },
    countryChange(e) {
    },
    handleVal() {
      let arr = []
      for (let i = 0; i < this.value1.length; i++) {
        let a = this.value1[i]
        let b = this.value2[i]
        let c = this.value3[i]
        if (c) {
          arr.push([a[0], b[0], c[0]])
        } else if (b) {
          arr.push([a[0], b[0]])
        } else {
          arr.push([a[0]])
        }
      }
      this.subData = arr
    }
  },
};
</script>
<style lang="scss"  scoped>
.container {
  position: relative;
  // min-height: 72.0rem;
}

.form {
  position: relative;
  margin-top: 7.0rem;
  z-index: 2;
}

.ex-cls {
  cursor: pointer;
}

.el-form-item__content {
  font-size: 1.3rem;
  color: #606266;
}

.footer {
  padding: 5.0rem 0;

}
.footer-box{
  display: flex;
  justify-content: center;

}

.clear-number-input ::v-deep input[type="number"]::-webkit-outer-spin-button,
.clear-number-input ::v-deep input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

.clear-number-input ::v-deep input[type="number"] {
  -moz-appearance: textfield !important;
}

.area-item {
  display: flex;
  align-items: center;
}

// 海报
.form-step-4 {
  display: flex;

  &-left {
    margin-right: 5.0rem;
  }
}

.background {
  width: 39.1rem;
  height: 68.5rem;
  border: .8rem solid rgb(241, 241, 241);
  position: relative;
}

.background-img-box {
  position: relative;
  width: 37.5rem;
  height: 66.7rem;

  .background-img {
    max-width: 100%;
    max-height: 100%;
  }

  .avatar {
    border: .1rem dashed #333;
    border-radius: 50%;
  }

  .nickname {
    border: .1rem dashed #333;
  }

  .qrcode {
    box-sizing: border-box;
    padding: .6rem;
    border: .1rem dashed #333;
  }
}

.vdr {
  position: absolute;
  top: 0;
}

// 活动欢迎语
.form-step-5 {
  display: flex;
  justify-content: space-between;

  &-right {
    margin: 0 6.0rem;
    overflow: hidden;

    .avatar-img {
      width: 3.6rem;
      height: 3.6rem;
    }
  }
}

// 欢迎语右侧预览图
.form-step-5-right {
  width: 37.5rem;
  // background-color: #f5f5f5;
  // border: .1rem solid #b8b8b8;
  overflow: hidden;

  .mobile {
    width: 60%;
    position: relative;
    top: 11.0rem;
    left: 4.5rem;
  }

  .mobile-header {
    &-img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  .list-item {
    margin: 2.0rem 1.5rem;
    display: flex;

    .list-item-l {
      margin-right: .6rem;

      img {
        width: 3.6rem;
        height: 3.6rem;
        border-radius: 50%;
      }
    }

    .list-item-r {
      background-color: #fff;
      padding: 1.0rem;
      border: .1rem solid rgb(219, 219, 219);
      border-radius: .2rem;
      line-height: 1.5;
      color: #333;
      font-size: 1.2rem;
      overflow: hidden;
      word-wrap: break-word;
      word-break: break-all;

      &-b {
        display: flex;
        color: #c3c3c3;

        &-l {
          // padding-right: 1.0rem;
          width: 50%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom: .6rem;
        }

        &-r {
          margin-left: .8rem;

          img {
            width: 2.0rem;
            height: 2.0rem;
          }
        }
      }
    }
  }
}

.item {
  width: 77.0rem;
  height: 5.0rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 6.0rem;
}

.btn {
  width: 15.0rem;
  display: flex;
  justify-content: space-between;
}
.main{
  background-color: #ffffff;
  border-radius: .8rem;
  padding: 4.0rem 2.0rem ;
}
::v-deep .el-input--small .el-input__inner,
::v-deep .el-range-editor--small.el-input__inner{
  width: 47.0rem;
height: 4.0rem;
background: #FFFFFF;
border-radius: .8rem;
border: .1rem solid #E6E6E6;

font-size: 1.6rem;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #999999;
line-height: 2.2rem;
}
 ::v-deep .el-icon-time:before,
::v-deep .el-range-editor--small .el-range__close-icon, .el-range-editor--small .el-range__icon{
  display: none ;
}
::v-deep .el-range-editor--small .el-range-input{
  font-size: 1.6rem;
  text-align: left;
}
::v-deep .el-range-editor--small .el-range-separator{
  line-height: 3.2rem ;
}
.el-form-item{
  margin-bottom: 3.0rem !important;
}
::v-deep .el-input--mini .el-input__inner{
  width: 6.0rem ;
  height: 4.0rem;
  line-height: 4.0rem;
}
/*步骤条 */
::v-deep .el-step__line{
  background-color:none ;
  height: 4.2rem !important;
    width: 7.1rem;
    margin-left: 16.2rem;

}
/*灰箭头 */
::v-deep .is-process .el-step__line{

  background: url('../../assets/箭头灰.png');
  background-size: 100% 100%;


}
::v-deep .is-wait .el-step__line{
  background: url('../../assets/箭头灰.png');
  background-size: 100% 100%;
}
::v-deep .is-success .el-step__line{
  background: url('../../assets/箭头绿.png');
  background-size: 100% 100%;


}
/*圆*/
::v-deep .is-success .el-step__icon.is-text{
  width: 6.0rem;
  height: 6.0rem;
  background: url('../../assets/iconGreen.png');
  background-size: 100% 100%;
  border: .0rem;
}
::v-deep .is-process .el-step__icon.is-text{
  width: 6.0rem;
  height: 6.0rem;
  background: url('../../assets/icona.png');
  background-size: 100% 100%;
  border: .0rem;
}
::v-deep .is-wait .el-step__icon.is-text{
  width: 6.0rem;
  height: 6.0rem;
  background: url('../../assets/iconGrey.png');
  background-size: 100% 100%;
  border: .0rem;
}
::v-deep .el-step__icon-inner{
  display: none;
}
::v-deep .el-step__line-inner{
  display: none;
}
::v-deep .el-steps--horizontal {

    padding: 0 4.0rem;
}
::v-deep .el-step__title.is-process{
  color:rgba($color: #49B372, $alpha: 0.5)
}
::v-deep .el-step__title.is-success{
color: #49B372;
}
</style>
